<script>
    import { code } from '../store.js'
    import { t, locale } from "../i18n/i18n";
	import { PUTONGHUA } from '../i18n/lang';
    import PlayFilledAlt from "carbon-icons-svelte/lib/PlayFilledAlt.svelte";
    import PauseFilled from "carbon-icons-svelte/lib/PauseFilled.svelte";
    import Restart from "carbon-icons-svelte/lib/Restart.svelte";
    import { onMount } from 'svelte';

    let audio_player, timebar, timetext;
    let interaction_triggered = false;

    let reverse_mode = localStorage.getItem('nsed-audio-guide.reverse_mode');

    onMount(async() => {
        code.subscribe((val)=>{ filename_subscribe(); });
        locale.subscribe((val)=>{ filename_subscribe(); });

        document.addEventListener('click', ()=>{
            if(interaction_triggered) return;
            interaction_triggered = true;
                Play();
        })

        // if(reverse_mode == null || reverse_mode=='false'){
        //     reverse_mode = false;
        // }else{
            reverse_mode = true;
        // }
    })

    const calculateTime = (secs) => {
        if(isNaN(secs))
            return `0:00`;
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${minutes}:${returnedSeconds}`;
    }

    const filename_subscribe = () =>{
        if(audio_player == undefined) return;
        audio_player.load();
    }
    
    const on_loadedmetadata = () => {
        timebar.max = Math.floor(audio_player.duration);
        timebar.value = 0;
        audio_player.currentTime = 0;
        if(!reverse_mode)
            timetext.innerHTML = '&numsp;0:00';
        else
            timetext.innerHTML = '-' + calculateTime(timebar.max);

        setTimeout(() => {
            Play();
        }, 300);
    }

    const onTimeUpdate = () => {
        timebar.value = Math.floor(audio_player.currentTime);
        if(!reverse_mode)
            timetext.innerHTML = '&numsp;' + calculateTime(audio_player.currentTime);
        else
            timetext.innerHTML = '-' + calculateTime(audio_player.duration - audio_player.currentTime);

        PinAnimationUpdate();
    };

    const Play = () => {
        audio_player.play();
    }

    const Replay = () => {
        audio_player.currentTime = 0;
        Play();
    }

    const Pause = () => {
        audio_player.pause();
    }

    const clickPlayIcon = () => {
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
        if(audio_player.readyState == HTMLMediaElement.HAVE_NOTHING) return;

        if(audio_player.ended){
            Replay();
            return;
        }
        if(audio_player.paused){
            Play();
            return;
        }
        Pause();
    }

    const Seek = (e) => {
        audio_player.currentTime = e.target.value;
    }

    const PinAnimationUpdate = () => {
        let pin = document.getElementById(`pin-${$code}`);
        if(audio_player.ended || audio_player.paused){
            pin.classList.add('audio-paused');
        }else{
            pin.classList.remove('audio-paused');
        }
    }

    const ToggleReverseMode = () => {
        reverse_mode = !reverse_mode;
        if(reverse_mode){            
            localStorage.setItem('nsed-audio-guide.reverse_mode', 'true');
            timetext.innerHTML = '-' + calculateTime(audio_player.duration - audio_player.currentTime);
        }else{
            localStorage.setItem('nsed-audio-guide.reverse_mode', 'false');
            timetext.innerHTML = '&numsp;' + calculateTime(audio_player.currentTime);
        }
    }
    
</script>

<div id='audio-player'>
    <audio 
        on:canplay={()=>{}} 
        bind:this={audio_player} 
        on:timeupdate={onTimeUpdate}
        on:loadedmetadata={on_loadedmetadata}
        >
        <source src="./assets/audio/{$t('audio.folder')}/{$code}{$t('audio.suffix')}.mp3?v=20251117" type="audio/mpeg"/>
    </audio>
    <div id="play-icon" on:click={clickPlayIcon}>
        {#if audio_player != undefined}
            {#if audio_player.ended}
                <Restart/>
            {:else if audio_player.paused}
                <PlayFilledAlt/>
            {:else}
                <PauseFilled/>
            {/if}
        {/if}
    </div>
    <input bind:this={timebar} type="range" id="seek-slider" on:change={Seek}/>
    <span bind:this={timetext} id="current-time" class="time" on:click={ToggleReverseMode}>0:00</span>
</div>

<style lang="scss">
    #audio-player{
        background-color: rgba(0, 51, 102, 0.8);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        width: calc(90% - 30px); /* 90% - padding-left & padding-right */
        max-width: 510px;
        min-height: 40px;
        align-self: center;
        padding: 6px 15px;

        #current-time,
        #play-icon{
            color: white;
        }

        #current-time{
            white-space: nowrap;
        }

        #play-icon{
            margin-top: 3px;
        }

        #seek-slider{
            position: relative;
            flex-grow: 1;
            -webkit-appearance: none;
            margin: 0;
            padding: 0;
            outline: none;
        }

        input[type="range"]::-webkit-slider-runnable-track {
            width: 100%;
            height: 3px;
            cursor: pointer;
            background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
        }
        input[type="range"]::before {
            position: absolute;
            content: "";
            top: 8px;
            left: 0;
            width: var(--seek-before-width);
            height: 3px;
            background-color: #007db5;
            cursor: pointer;
        }
        input[type="range"]::-webkit-slider-thumb {
            position: relative;
            -webkit-appearance: none;
            box-sizing: content-box;
            border: 1px solid #007db5;
            height: 15px;
            width: 15px;
            border-radius: 50%;
            background-color: #fff;
            cursor: pointer;
            margin: -7px 0 0 0;
        }
        input[type="range"]:active::-webkit-slider-thumb {
            transform: scale(1.2);
            background: #007db5;
        }
        #seek-slider::-moz-range-track {
            width: 100%;
            height: 3px;
            cursor: pointer;
            background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
        }
        #seek-slider::-moz-range-progress {
            background-color: #007db5;
        }
        #seek-slider::-moz-focus-outer {
            border: 0;
        }
        #seek-slider::-moz-range-thumb {
            box-sizing: content-box;
            border: 1px solid #007db5;
            height: 15px;
            width: 15px;
            border-radius: 50%;
            background-color: #fff;
            cursor: pointer;
        }
        #seek-slider:active::-moz-range-thumb {
            transform: scale(1.2);
            background: #007db5;
        }
        #seek-slider::-ms-track {
            width: 100%;
            height: 3px;
            cursor: pointer;
            background: transparent;
            border: solid transparent;
            color: transparent;
        }
        #seek-slider::-ms-fill-lower {
            background-color: #007db5;
        }
        #seek-slider::-ms-fill-upper {
            background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
        }
        #seek-slider::-ms-thumb {
            box-sizing: content-box;
            border: 1px solid #007db5;
            height: 15px;
            width: 15px;
            border-radius: 50%;
            background-color: #fff;
            cursor: pointer;
        }
        #seek-slider:active::-ms-thumb {
            transform: scale(1.2);
            background: #007db5;
        }
    }
</style>